<template>
  <div>
    <!-- NIVELES DE UBICACIÓN -->
    <div class="row">
      <div class="col">
        <temporaryLocations />
      </div>
      <div class="col">
        <niveles />

      </div>
    </div>


    <!-- UBICACIONES -->
    <locatiions />

    <!-- ARBOL DE UBICACIONES -->
    <tree></tree>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import niveles from "./niveles";
import locatiions from "./ubicaciones";
import tree from "./ubicaciones-empresa";
import temporaryLocations from "./temporaryLocations";

export default {
  name: "index",
  async mounted() {
    await this.listLevels();
    await this.listarUbicaciones()
    await this.arbolUbicacionesEmpresa();
    await this.getTemporaryLocations();
  },
  components: {
    niveles,
    locatiions,
    tree,
    temporaryLocations
  },
  methods: {
    ...mapActions("location", [
      "listLevels",
      "listarUbicaciones",
      "arbolUbicacionesEmpresa",
      "getTemporaryLocations"
    ]),
  },
};
</script>

